import { useMemo, useState } from "react";

import { Button, ButtonStyle, Modal, TextArea } from "@prequel/shared-components";

import { parseRecordIDs } from "@/pages/import/StreamsPage/helpers";

type RunExtractModalProps = {
  isSubmitting: boolean;
  onCancel: () => void;
  onSubmit: (recordIDs: string[]) => void;
};

const RunExtractModal = ({ isSubmitting, onCancel, onSubmit }: RunExtractModalProps) => {
  const [recordIDs, setRecordIDs] = useState("");
  const parsedRecordIDs = useMemo(() => parseRecordIDs(recordIDs), [recordIDs]);

  return (
    <div className="space-y-4">
      <div className="text-left">
        <Modal.Title as="h3" className="text-lg/6 font-medium text-stone-900">
          Run custom extract
        </Modal.Title>
        <p className="mt-1 text-sm text-stone-500">Extract only these record IDs.</p>
      </div>
      <div className="h-px w-full bg-stone-200" />

      <TextArea
        id="extract_record_ids_modal"
        label="Record IDs"
        placeholder="rec_001, rec_002, rec_003"
        value={recordIDs}
        onChangeHandler={setRecordIDs}
        subtext="Whitespace or comma separated, or paste a JSON array."
      />

      <div className="h-px w-full bg-stone-200" />
      <div className="space-x-3">
        <Button
          text="Queue Extract"
          type={ButtonStyle.SECONDARY}
          disabled={parsedRecordIDs.length === 0 || isSubmitting}
          onClick={() => onSubmit(parsedRecordIDs)}
        />
        <Button text="Cancel" type={ButtonStyle.TERTIARY} onClick={onCancel} />
      </div>
    </div>
  );
};

export default RunExtractModal;
